import { useEffect } from "react"
import { TopBar } from "../../shared/topBar/TopBar"

export const CilentReturnsAnalytics=()=>{
    useEffect(()=>{
        document.title="Analytics"
    },[]);
    return <>
    <TopBar label={"Client Return Analytics"} />
        <div  className="mainContentData">
         
        </div>
    </>
}